import { __ } from "@wordpress/i18n";
import ColorSettings from "./ColorSettings";
import {
  PanelBody,
  __experimentalBorderBoxControl as BorderBoxControl,
  __experimentalToolsPanel as ToolsPanel,
  __experimentalToolsPanelItem as ToolsPanelItem,
} from "@wordpress/components";

export default function AddedStateStyleSettings({ attributes, setAttributes }) {
  const { addedStyles } = attributes;
  const handleUpdateColorValue = (key, value) => {
    setAttributes({
      addedStyles: { ...addedStyles, [key]: value },
    });
  };
  return (
    <>
      <PanelBody title={__("Added State Styles", "brandy")} initialOpen={false}>
        <div className="brandy-add-to-compare-list-color-settings">
          <ColorSettings
            title={__("Colors", "brandy-blocks")}
            backgroundColor={addedStyles.backgroundColor}
            textColor={addedStyles.textColor}
            handleUpdateColorValue={handleUpdateColorValue}
          />
        </div>
        <div className="brandy-add-to-compare-list-border-settings">
          <ToolsPanel label={__("Borders", "brandy-blocks")}>
            <ToolsPanelItem
              hasValue={() => true}
              label={__("Border", "brandy")}
              onDeselect={() => {
                setAttributes({
                  addedStyles: { ...addedStyles, borders: {} },
                });
              }}
              isShownByDefault
            >
              <BorderBoxControl
                colors={
                  wp.data.select("core/editor").getEditorSettings().colors
                }
                label={__("Borders", "brandy-blocks")}
                value={addedStyles.borders}
                onChange={(value) => {
                  handleUpdateColorValue("borders", value);
                }}
              />
            </ToolsPanelItem>
          </ToolsPanel>
        </div>
      </PanelBody>
    </>
  );
}
